/**
 * Super Admin Service
 * Handles super admin dashboard and cross-org visibility endpoints
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { SUPER_ADMIN_ENDPOINTS, buildQueryString } from '../endpoints';

const superAdminService = {
  getDashboard: async () => {
    return apiRequest(() =>
      axiosInstance.get(SUPER_ADMIN_ENDPOINTS.DASHBOARD)
    );
  },

  getOrganizationsOverview: async (includeInactive = false) => {
    const params = includeInactive ? '?includeInactive=true' : '';
    return apiRequest(() =>
      axiosInstance.get(`${SUPER_ADMIN_ENDPOINTS.ORGANIZATIONS_OVERVIEW}${params}`)
    );
  },

  getOrganizationSummary: async (orgId) => {
    return apiRequest(() =>
      axiosInstance.get(SUPER_ADMIN_ENDPOINTS.ORGANIZATION_SUMMARY(orgId))
    );
  },

  getOrganizationCustomers: async (orgId, { search, page = 1, pageSize = 20 } = {}) => {
    const qs = buildQueryString({ search, page, pageSize });
    return apiRequest(() =>
      axiosInstance.get(`${SUPER_ADMIN_ENDPOINTS.ORGANIZATION_CUSTOMERS(orgId)}${qs}`)
    );
  },
};

export default superAdminService;
